import api from '@/api/api_geodp'

export default class InvoicesPaymentService {
  sendPayment (payment) {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       item: 'https://www.tipi.budget.gouv.fr/tpa/paiementws.web?idop=idop_de_test',
    //       error: {
    //         code: 0,
    //         message: "[MOCK DATA] Ce numéro de facture n'existe pas."
    //       },
    //       success: true
    //     })
    //   }, 1500)
    // })

    return api.post('invoices/' + payment.invoiceNumber + '/payment', payment)
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== '500' && error.response.data) {
            return new Promise((resolve) => { resolve(error.response.data) })
          }
        }
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/invoicesPaymentService.js